import { FC } from 'react';
import { Container } from 'atoms/Container';
import { VideoPlayer } from 'molecules/VideoPlayer';
import styles from './styles.module.css';

export const YoutubeVideo: FC<{ blok: { link: string } }> = ({ blok }) => {
  return (
    <Container>
      <VideoPlayer url={blok.link} light={false} className={styles.player} />
    </Container>
  );
};
